"use client";

import { useStyles } from "./styles";
import { MODELS } from "../../constants";
import PowerLevelItem from "./PowerLevelItem";

interface PowerLevelsProps {
  selectedModel: string;
}

const PowerLevels: React.FC<PowerLevelsProps> = ({ selectedModel }) => {
  const { classes } = useStyles();
  const model = MODELS.find((m) => m.name === selectedModel) || MODELS[0];

  return (
    <div className={classes.container}>
      <PowerLevelItem variant="text" value={model.textScore} />
      <PowerLevelItem variant="quality" value={model.qualityScore} />
      <PowerLevelItem variant="speed" value={model.speedScore} />
      <PowerLevelItem variant="fandom" value={model.fandomScore} />
    </div>
  );
};

export default PowerLevels;
